import { useEffect, useRef, useState } from "react"

type UseParentDisplayCheckReturn = {
    containerRef: React.RefObject<HTMLDivElement>
    isParentVisible: boolean
}

export const useParentDisplayCheck = (): UseParentDisplayCheckReturn => {
    const containerRef = useRef<HTMLDivElement | null>(null)
    const [isParentVisible, setIsParentVisible] = useState(true)

    useEffect(() => {
        const container = containerRef.current
        const parent = container?.parentElement

        if (!parent) return

        const checkDisplay = () => {
            const display = window.getComputedStyle(parent).display
            setIsParentVisible(display !== "none")
        }

        checkDisplay()

        const observer = new MutationObserver(() => {
            checkDisplay()
        })

        observer.observe(parent, {
            attributes: true,
            attributeFilter: ["style", "class"],
        })

        return () => {
            observer.disconnect()
        }
    }, [])

    return { containerRef, isParentVisible }
}
